import { createSlice } from '@reduxjs/toolkit'

export const initialState = {}

export const featureFlagsSliceConfig = {
  name: 'featureFlags',
  initialState: initialState,
  reducers: {}
}

export const featureFlagsSlice = createSlice(featureFlagsSliceConfig)
export const { reducer: featureFlagsReducer } = featureFlagsSlice